
export type PostApiV1RefundsCancelSubscriptionBody = {
  /**
   * 취소 사유 (선택사항)
   * @maxLength 500
   */
  reason?: string;
  /** 취소할 구독 ID */
  subscriptionId: number;
};
